import "./AuthLayout.css";

import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="AuthLayout-page-content" data-testid="auth-layout-div">
      <Outlet />
    </div>
  )
};

export default AuthLayout;